module.exports = __webpack_public_path__ + "static/media/star-shooting.31f186d1.svg";